import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

const ColumnTabs = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            callback: PropTypes.func,
            type: PropTypes.string,
        };

        constructor(props) {
            super(props);

            this.state = {
                current: 0,
                tabsList: {
                    ifootball: [
                        {
                            dataKey: 'dataYC',
                            dataName: '英超',
                        },
                        {
                            dataKey: 'dataXJ',
                            dataName: '西甲',
                        },

                        {
                            dataKey: 'dataYJ',
                            dataName: '意甲',
                        },
                        {
                            dataKey: 'dataDJ',
                            dataName: '德甲',
                        },
                        {
                            dataKey: 'dataFJ',
                            dataName: '法甲',
                        },
                    ],
                    nba: [
                        {
                            dataKey: 'dataF',
                            dataName: '东部',
                        },
                        {
                            dataKey: 'dataE',
                            dataName: '西部',
                        },
                    ],
                },
            };
        }

        handleMouseOver = current => {
            this.setState({
                current,
            });
        };

        render() {
            const { callback, type } = this.props;
            const { tabsList, current } = this.state;

            return (
                <ul className={`${styles.rightColumnTab} ${type === 'nba' ? styles.nbaT : null}`}>
                    {tabsList[type]
                        ? tabsList[type].map((item, index) => (
                              <li
                                  key={index}
                                  className={current === index ? styles.current : null}
                                  onMouseOver={() => {
                                      callback(index, item.dataKey, type);
                                      this.handleMouseOver(index);
                                  }}>
                                  {item.dataName}
                              </li>
                          ))
                        : null}
                </ul>
            );
        }
    },
);

export { ColumnTabs };
export default ColumnTabs;
